import { render, staticRenderFns } from "./CustomFormElementsSelect.vue?vue&type=template&id=4f0d60e1&scoped=true"
import script from "./CustomFormElementsSelect.vue?vue&type=script&lang=js"
export * from "./CustomFormElementsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d60e1",
  null
  
)

export default component.exports